export const ok = <T>(value: T): value is Exclude<T, null | undefined> =>
  ((value !== undefined && value !== null) || undefined) as boolean
